import { create } from 'zustand';

export const SUPER_ADMIN_EMAILS = [
  'facil@facil.com',
  'alejandro.jerez@gmail.com',
  'marcelo@transportesemilia.cl',
];

export const isSuperAdminUser = (user, originalAdminUser = null) => {
  const realEmail = (
    originalAdminUser?.email ||
    user?.impersonated_by ||
    user?.email ||
    ''
  )
    .toString()
    .trim()
    .toLowerCase();
  return SUPER_ADMIN_EMAILS.includes(realEmail);
};

const safeParseJSON = (val) => {
  if (!val) return null;
  try {
    return JSON.parse(val);
  } catch {
    return null;
  }
};

const useAuthStore = create((set, get) => ({
  token: localStorage.getItem('token') || null,
  user: safeParseJSON(localStorage.getItem('user')),
  isAuthenticated: !!localStorage.getItem('token'),
  originalAdminToken: localStorage.getItem('super_admin_original_token') || null,
  originalAdminUser: safeParseJSON(localStorage.getItem('super_admin_original_user')),
  isImpersonating: !!localStorage.getItem('super_admin_original_token'),

  login: (token, user) => {
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(user));
    set({
      token,
      user,
      isAuthenticated: true,
      isImpersonating: !!localStorage.getItem('super_admin_original_token'),
    });
  },

  startImpersonation: (impersonatedToken, impersonatedUser) => {
    const state = get();
    let origToken = state.originalAdminToken || localStorage.getItem('super_admin_original_token');
    let origUser = state.originalAdminUser || safeParseJSON(localStorage.getItem('super_admin_original_user'));

    if (!origToken && state.token && state.user) {
      origToken = state.token;
      origUser = state.user;
      localStorage.setItem('super_admin_original_token', origToken);
      localStorage.setItem('super_admin_original_user', JSON.stringify(origUser));
    }

    localStorage.setItem('token', impersonatedToken);
    localStorage.setItem('user', JSON.stringify(impersonatedUser));

    set({
      token: impersonatedToken,
      user: impersonatedUser,
      isAuthenticated: true,
      originalAdminToken: origToken,
      originalAdminUser: origUser,
      isImpersonating: true,
    });
  },

  stopImpersonation: () => {
    const origToken = localStorage.getItem('super_admin_original_token');
    const origUser = safeParseJSON(localStorage.getItem('super_admin_original_user'));

    if (origToken && origUser) {
      localStorage.setItem('token', origToken);
      localStorage.setItem('user', JSON.stringify(origUser));
      localStorage.removeItem('super_admin_original_token');
      localStorage.removeItem('super_admin_original_user');
      set({
        token: origToken,
        user: origUser,
        isAuthenticated: true,
        originalAdminToken: null,
        originalAdminUser: null,
        isImpersonating: false,
      });
      return true;
    }
    return false;
  },

  logout: async () => {
    const token = localStorage.getItem('token');
    
    // Limpiar localStorage y estado inmediatamente para evitar condiciones de carrera en recargas de página
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('super_admin_original_token');
    localStorage.removeItem('super_admin_original_user');
    set({
      token: null,
      user: null,
      isAuthenticated: false,
      originalAdminToken: null,
      originalAdminUser: null,
      isImpersonating: false,
    });

    if (token) {
      let baseURL = 'https://flujo-app-backend.onrender.com';
      if (process.env.REACT_APP_API_URL) {
        baseURL = process.env.REACT_APP_API_URL;
      } else if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
        baseURL = 'http://localhost:8000';
      }
      try {
        await fetch(`${baseURL}/auth/logout`, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
      } catch (err) {
        console.error("Error during remote logout call:", err);
      }
    }
  },

  // Optional: A function to initialize the store from localStorage on app load
  initializeAuth: () => {
    const token = localStorage.getItem('token');
    const user = safeParseJSON(localStorage.getItem('user'));
    const origToken = localStorage.getItem('super_admin_original_token') || null;
    const origUser = safeParseJSON(localStorage.getItem('super_admin_original_user'));
    if (token && user) {
      set({
        token,
        user,
        isAuthenticated: true,
        originalAdminToken: origToken,
        originalAdminUser: origUser,
        isImpersonating: !!origToken,
      });
    }
  },
}));

export default useAuthStore;

